import React, { Fragment } from "react";

// オプション料金表示変換処理
export const optionPriceConvertDisplay = (option_price) => {
  switch(option_price){
    case '0':
      return (
        <Fragment>（無料）</Fragment>
      )
    default:
      return (
        <Fragment>（¥ {option_price}）</Fragment>
      )
  }
};